import _asyncToGenerator from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { useMemo } from 'react';
import { ENDPOINTS } from '../../endpoints';
import { Service } from '../base';
import dynamicAxios from '../../utils/axios';
import useServices from '../../hooks/useServices';
import { exploreJobPositionsQuery, exploreStaticJobPositionsQuery, indexJobPositionsQuery } from './graphqlQueries';

var ServiceJobPositions = /*#__PURE__*/function (_Service) {
  _inherits(ServiceJobPositions, _Service);

  var _super = _createSuper(ServiceJobPositions);

  function ServiceJobPositions() {
    _classCallCheck(this, ServiceJobPositions);

    return _super.apply(this, arguments);
  }

  _createClass(ServiceJobPositions, [{
    key: "fetchJobPositions",
    value: // deprecate after merging the current implementation with the new grapqhl query
    function fetchJobPositions(_ref) {
      var restaurantId = _ref.restaurantId,
          limit = _ref.limit,
          offset = _ref.offset,
          order_by = _ref.order_by,
          filters = _ref.filters;
      var appliedFilters = filters || {};
      return this.axiosInstance.get(ENDPOINTS.jobPositions.root, {
        params: _objectSpread(_objectSpread({
          limit: limit,
          offset: offset,
          restaurant_id: restaurantId
        }, appliedFilters), {}, {
          order_by: order_by
        })
      });
    }
  }, {
    key: "listJobPositions",
    value: function listJobPositions(_ref2) {
      var limit = _ref2.limit,
          offset = _ref2.offset,
          order_by = _ref2.order_by,
          employer_id = _ref2.employer_id,
          search_vector = _ref2.search_vector,
          organization_id = _ref2.organization_id,
          restaurant_name = _ref2.restaurant_name,
          status = _ref2.status,
          locality = _ref2.locality,
          occupation_id = _ref2.occupation_id,
          show_performance_metrics = _ref2.show_performance_metrics;
      return this.axiosInstance.post(ENDPOINTS.employers.graphql, {
        query: indexJobPositionsQuery,
        variables: {
          limit: limit,
          offset: offset,
          order_by: order_by,
          employer_id: employer_id,
          search_vector: search_vector,
          organization_id: organization_id,
          restaurant_name: restaurant_name,
          status: status,
          locality: locality,
          occupation_id: occupation_id,
          show_performance_metrics: show_performance_metrics
        }
      });
    }
  }, {
    key: "duplicate",
    value: function duplicate(_ref3) {
      var jobPositionId = _ref3.jobPositionId,
          restaurantId = _ref3.restaurantId,
          params = _ref3.params;
      return this.axiosInstance.post(ENDPOINTS.jobPositions.duplicate, _objectSpread({
        restaurant_id: restaurantId,
        job_position_id: jobPositionId
      }, params || {}));
    }
  }, {
    key: "showJobPosition",
    value: function showJobPosition(jobPositionId) {
      return this.axiosInstance.get("".concat(ENDPOINTS.jobPositions.root, "/").concat(jobPositionId));
    }
  }, {
    key: "exportApplicationsCsv",
    value: function exportApplicationsCsv(jobPositionId) {
      return this.axiosInstance.get("".concat(ENDPOINTS.jobPositions.root, "/").concat(jobPositionId, "/applications/export.csv"), {
        responseType: 'blob'
      });
    }
  }, {
    key: "showJobPositionStats",
    value: function showJobPositionStats(jobPositionId) {
      return this.axiosInstance.get("".concat(ENDPOINTS.jobPositions.stats), {
        params: {
          job_position_id: jobPositionId
        }
      });
    } // To check if the JP is active or not

  }, {
    key: "showJobPositionStatus",
    value: function showJobPositionStatus(jobPositionId, check_active_job_applications) {
      return this.axiosInstance.get("".concat(ENDPOINTS.jobPositions.active_status, "/").concat(jobPositionId), {
        params: {
          check_active_job_applications: check_active_job_applications
        }
      });
    }
  }, {
    key: "updateJobPosition",
    value: function updateJobPosition(_ref4) {
      var jobPositionId = _ref4.jobPositionId,
          params = _ref4.params;
      return this.axiosInstance.put("".concat(ENDPOINTS.jobPositions.root, "/").concat(jobPositionId), params);
    }
  }, {
    key: "updateJobPositionStatus",
    value: function updateJobPositionStatus(_ref5) {
      var jobPositionId = _ref5.jobPositionId,
          newStatusKey = _ref5.newStatusKey,
          params = _ref5.params;
      return this.axiosInstance.patch("".concat(ENDPOINTS.jobPositions.status, "/").concat(jobPositionId), _objectSpread({
        status_key: newStatusKey
      }, params));
    }
  }, {
    key: "deleteJobPosition",
    value: function deleteJobPosition(jobPositionId) {
      return this.axiosInstance["delete"]("".concat(ENDPOINTS.jobPositions.root, "/").concat(jobPositionId));
    }
  }, {
    key: "putOfflineJobPosition",
    value: function putOfflineJobPosition(jobPositionId, delaySeconds) {
      return this.axiosInstance.patch("".concat(ENDPOINTS.jobPositions.root, "/offline"), _objectSpread({
        id: jobPositionId
      }, delaySeconds !== undefined && {
        delay_seconds: delaySeconds
      }));
    }
  }, {
    key: "assignCsm",
    value: function assignCsm(_ref6) {
      var userId = _ref6.userId,
          jobPositionId = _ref6.jobPositionId;
      return this.axiosInstance.post(ENDPOINTS.jobPositions.assignCsm, {
        customer_success_manager_id: userId,
        job_position_id: jobPositionId
      });
    }
  }, {
    key: "makeCsmMain",
    value: function makeCsmMain(_ref7) {
      var userId = _ref7.userId,
          jobPositionId = _ref7.jobPositionId;
      return this.axiosInstance.post(ENDPOINTS.jobPositions.makeCsmMain, {
        customer_success_manager_id: userId,
        job_position_id: jobPositionId
      });
    }
  }, {
    key: "removeCsm",
    value: function removeCsm(_ref8) {
      var userId = _ref8.userId,
          jobPositionId = _ref8.jobPositionId;
      return this.axiosInstance["delete"](ENDPOINTS.jobPositions.removeCsm, {
        data: {
          customer_success_manager_id: userId,
          job_position_id: jobPositionId
        }
      });
    }
  }, {
    key: "addTask",
    value: function addTask(_ref9) {
      var jobPositionId = _ref9.jobPositionId,
          task = _ref9.task;
      return this.axiosInstance.post(ENDPOINTS.jobPositions.task, _objectSpread(_objectSpread({}, task), {}, {
        job_position_id: jobPositionId
      }));
    }
  }, {
    key: "updateTask",
    value: function updateTask(_ref10) {
      var _params$category_var, _params$sub_category_;

      var taskId = _ref10.taskId,
          params = _ref10.params;
      return this, this.axiosInstance.patch(ENDPOINTS.jobPositions.task, _objectSpread(_objectSpread({
        id: taskId
      }, params), {}, {
        category: ((_params$category_var = params.category_var) === null || _params$category_var === void 0 ? void 0 : _params$category_var.id) || params.category,
        sub_category: ((_params$sub_category_ = params.sub_category_var) === null || _params$sub_category_ === void 0 ? void 0 : _params$sub_category_.id) || params.sub_category
      }));
    }
  }, {
    key: "deleteTask",
    value: function deleteTask(taskId) {
      return this.axiosInstance["delete"](ENDPOINTS.jobPositions.task, {
        data: {
          id: taskId
        }
      });
    }
  }, {
    key: "getTask",
    value: function getTask(taskId) {
      return this.axiosInstance.get(ENDPOINTS.jobPositions.task, {
        params: {
          id: taskId
        }
      });
    }
  }, {
    key: "getJobPositionApplicationPerformanceMetrics",
    value: function getJobPositionApplicationPerformanceMetrics(jobPositionId) {
      return this.axiosInstance.get(ENDPOINTS.jobPositions.applicationPerformanceMetrics, {
        params: {
          job_position_id: jobPositionId
        }
      });
    }
  }, {
    key: "indexPublicJobPositions",
    value: function indexPublicJobPositions() {
      return this.axiosInstance.get("".concat(ENDPOINTS.jobPositions.root, "/active"));
    }
  }, {
    key: "fetchActiveJobPosition",
    value: function fetchActiveJobPosition(id) {
      return this.axiosInstance.get("".concat(ENDPOINTS.jobPositions.root, "/active/").concat(id));
    }
  }, {
    key: "indexReferralJobPositions",
    value: function indexReferralJobPositions() {
      return this.axiosInstance.get(ENDPOINTS.jobPositions.referralJobPositions);
    }
  }, {
    key: "createJobPositionViewLog",
    value: function createJobPositionViewLog(_ref11) {
      var jobPositionId = _ref11.jobPositionId,
          ambassadorCode = _ref11.ambassadorCode,
          utmSource = _ref11.utmSource,
          isViola = _ref11.isViola,
          ipAddress = _ref11.ipAddress;
      return this.axiosInstance.post(ENDPOINTS.jobPositions.jobPositionViewLog, {
        job_position_id: jobPositionId,
        ambassador_code: ambassadorCode,
        utm_source: utmSource,
        is_viola: isViola,
        id_address: ipAddress
      });
    }
  }, {
    key: "createJobPosition",
    value: function createJobPosition(_ref12) {
      var params = _ref12.params;
      return this.axiosInstance.post(ENDPOINTS.jobPositions.root, _objectSpread({}, params));
    }
  }, {
    key: "similarJobPositions",
    value: function similarJobPositions(jobPositionId, opts) {
      return this.axiosInstance.get("".concat(ENDPOINTS.jobPositions.similarJobs, "/").concat(jobPositionId), {
        params: _objectSpread(_objectSpread({}, (opts === null || opts === void 0 ? void 0 : opts.limit) != null ? {
          limit: opts.limit
        } : {}), (opts === null || opts === void 0 ? void 0 : opts.offset) != null ? {
          offset: opts.offset
        } : {})
      });
    }
  }, {
    key: "createFavoriteJobPosition",
    value: function createFavoriteJobPosition(_ref13) {
      var jobPositionId = _ref13.jobPositionId,
          email = _ref13.email;
      return this.axiosInstance.post("".concat(ENDPOINTS.jobPositions.favoriteJob), {
        job_position_id: jobPositionId,
        email: email
      });
    }
  }, {
    key: "isJobPositionFavorite",
    value: function isJobPositionFavorite(jobPositionId) {
      return this.axiosInstance.get("".concat(ENDPOINTS.jobPositions.isJobFavorite, "/").concat(jobPositionId));
    }
  }, {
    key: "deleteFavoriteJobPosition",
    value: function deleteFavoriteJobPosition(jobPositionId) {
      return this.axiosInstance["delete"]("".concat(ENDPOINTS.jobPositions.favoriteJob, "/").concat(jobPositionId));
    }
  }, {
    key: "getJobPositionApplicationPerformanceWorkerMetrics",
    value: function getJobPositionApplicationPerformanceWorkerMetrics(jobPositionId) {
      return this.axiosInstance.get(ENDPOINTS.jobPositions.applicationPerformanceMetrics, {
        params: {
          job_position_id: jobPositionId
        }
      });
    }
  }, {
    key: "showGenerationPrompt",
    value: function showGenerationPrompt(jobPositionId, category) {
      return this.axiosInstance.get(ENDPOINTS.jobPositions.showGenerationPrompt, {
        params: {
          job_position_id: jobPositionId,
          category: category
        }
      });
    }
  }, {
    key: "chatCompletion",
    value: function chatCompletion(jobPositionId, category, inputPrompt) {
      return this.axiosInstance.get(ENDPOINTS.jobPositions.chatCompletion, {
        params: {
          job_position_id: jobPositionId,
          category: category,
          input_prompt: inputPrompt
        }
      });
    }
    /**
     * Generates job title, description, and contract description in a single call.
     * The content is automatically saved to the database.
     * @param jobPositionId - The ID of the job position
     * @returns Object with job_title, job_description, and job_contract_description
     */

  }, {
    key: "generateAdContent",
    value: function generateAdContent(jobPositionId) {
      return this.axiosInstance.post(ENDPOINTS.jobPositions.generateAdContent, null, {
        params: {
          job_position_id: jobPositionId
        }
      });
    }
    /**
     * Generates ad content from raw JP data (for org onboarding when JP is not yet in DB).
     * Sends the JP form data directly to the backend for AI generation.
     * @param jpData - The job position form data
     * @returns Object with job_title, job_description, and job_contract_description
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "generateAdContentFromData",
    value: function generateAdContentFromData(jpData) {
      return this.axiosInstance.post(ENDPOINTS.jobPositions.generateAdContent, {
        job_position_data: jpData
      });
    }
    /**
     * @deprecated Use generateAdContent() instead. This endpoint will be removed in a future version.
     */

  }, {
    key: "createJobTitle",
    value: function createJobTitle(jobPositionId) {
      return this.axiosInstance.get(ENDPOINTS.jobPositions.createJobTitle, {
        params: {
          job_position_id: jobPositionId
        }
      });
    }
    /**
     * @deprecated Use generateAdContent() instead. This endpoint will be removed in a future version.
     */

  }, {
    key: "createJobDescription",
    value: function createJobDescription(jobPositionId) {
      return this.axiosInstance.get(ENDPOINTS.jobPositions.createJobDescription, {
        params: {
          job_position_id: jobPositionId
        }
      });
    }
    /**
     * @deprecated Use generateAdContent() instead. This endpoint will be removed in a future version.
     */

  }, {
    key: "createJobContractDescription",
    value: function createJobContractDescription(jobPositionId) {
      return this.axiosInstance.get(ENDPOINTS.jobPositions.createJobContractDescription, {
        params: {
          job_position_id: jobPositionId
        }
      });
    }
  }, {
    key: "indexRegions",
    value: function indexRegions() {
      return this.axiosInstance.get(ENDPOINTS.jobPositions.regions);
    }
  }, {
    key: "getJobLocationCoordinates",
    value: function getJobLocationCoordinates(params, config) {
      return this.axiosInstance.get(ENDPOINTS.jobPositions.JobLocationCoordinates, _objectSpread({
        params: params
      }, config));
    }
  }, {
    key: "getJobLocationPositionList",
    value: function () {
      var _getJobLocationPositionList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params, config) {
        var r;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.axiosInstance.post(ENDPOINTS.employers.graphql, {
                  query: exploreJobPositionsQuery,
                  variables: _objectSpread({}, params)
                }, _objectSpread({}, config));

              case 2:
                r = _context.sent;
                return _context.abrupt("return", r);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getJobLocationPositionList(_x, _x2) {
        return _getJobLocationPositionList.apply(this, arguments);
      }

      return getJobLocationPositionList;
    }()
  }, {
    key: "fetchJobPositionsGroupedCount",
    value: function fetchJobPositionsGroupedCount() {
      return this.axiosInstance.get(ENDPOINTS.jobPositions.groupedCount, {
        params: {
          count: 'domain_interest'
        }
      });
    }
  }, {
    key: "exploreStaticJobPositions",
    value: function exploreStaticJobPositions(_ref14) {
      var occupationId = _ref14.occupationId,
          restaurantId = _ref14.restaurantId,
          employerId = _ref14.employerId;
      return this.axiosInstance.post(ENDPOINTS.employers.graphql, {
        query: exploreStaticJobPositionsQuery,
        variables: {
          occupation_id: occupationId,
          employer_id: employerId,
          restaurant_id: restaurantId
        }
      });
    }
  }, {
    key: "assignJuniorRecruiter",
    value: function assignJuniorRecruiter(_ref15) {
      var jobPositionId = _ref15.jobPositionId,
          juniorRecruiterId = _ref15.juniorRecruiterId;
      return this.axiosInstance.post(ENDPOINTS.jobPositions.assignJR, {
        job_position_id: jobPositionId,
        junior_recruiter_id: juniorRecruiterId
      });
    }
  }, {
    key: "requestJuniorRecruiter",
    value: function requestJuniorRecruiter(_ref16) {
      var jobPositionId = _ref16.jobPositionId,
          requestedJr = _ref16.requestedJr;
      return this.axiosInstance.post("".concat(ENDPOINTS.jobPositions.root, "/request_assistance"), {
        job_position_id: jobPositionId,
        requested_jr: requestedJr
      });
    }
  }, {
    key: "setSeoData",
    value: function setSeoData(_ref17) {
      var job_position_id = _ref17.job_position_id,
          meta_background_image = _ref17.meta_background_image,
          meta_image = _ref17.meta_image,
          meta_image_text_tag_1 = _ref17.meta_image_text_tag_1,
          meta_image_text_tag_2 = _ref17.meta_image_text_tag_2,
          meta_image_text_tag_3 = _ref17.meta_image_text_tag_3,
          meta_description = _ref17.meta_description,
          meta_title = _ref17.meta_title;
      var formData = new FormData();
      formData.append('id', job_position_id);
      if (meta_background_image) formData.append('meta_background_image', meta_background_image);
      if (meta_image) formData.append('meta_image', meta_image);
      if (meta_image_text_tag_1) formData.append('meta_image_text_tag_1', meta_image_text_tag_1);
      if (meta_image_text_tag_2) formData.append('meta_image_text_tag_2', meta_image_text_tag_2);
      if (meta_image_text_tag_3) formData.append('meta_image_text_tag_3', meta_image_text_tag_3);
      if (meta_description) formData.append('meta_description', meta_description);
      if (meta_title) formData.append('meta_title', meta_title);
      return this.axiosInstance.post("".concat(ENDPOINTS.jobPositions.root, "/seo_metadata"), formData, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      });
    }
  }, {
    key: "isJobPositionActive",
    value: function isJobPositionActive(_ref18) {
      var jobPositionId = _ref18.jobPositionId,
          check_active_job_applications = _ref18.check_active_job_applications;
      return this.axiosInstance.get("".concat(ENDPOINTS.jobPositions.active_status, "/").concat(jobPositionId), {
        params: {
          check_active_job_applications: check_active_job_applications
        }
      });
    }
  }, {
    key: "requestToPublishJobPosition",
    value: function requestToPublishJobPosition(_ref19) {
      var jobPositionId = _ref19.jobPositionId;
      return this.axiosInstance.post("".concat(ENDPOINTS.jobPositions.root, "/").concat(jobPositionId, "/request_to_publish"));
    }
  }, {
    key: "getLatestValidation",
    value: function getLatestValidation(_ref20) {
      var jobPositionId = _ref20.jobPositionId;
      return this.axiosInstance.get("".concat(ENDPOINTS.jobPositions.root, "/").concat(jobPositionId, "/latest_validation"));
    }
  }, {
    key: "getRecommendedWorkersCount",
    value: function getRecommendedWorkersCount(_ref21) {
      var jobPositionId = _ref21.jobPositionId;
      return this.axiosInstance.get("".concat(ENDPOINTS.jobPositions.root, "/").concat(jobPositionId, "/recommended_workers_count"));
    }
    /**
     * Validate a job position ad.
     *
     * Accepts either:
     * - `{ jobPositionId }` - validates an existing JP from DB (with rate limiting)
     * - `{ jpData }` - validates raw JP data (org onboarding, no rate limit)
     *
     * Both modes use the same backend endpoint with different params.
     */

  }, {
    key: "validateAd",
    value: function validateAd(params) {
      var requestBody = 'jobPositionId' in params ? {
        id: params.jobPositionId
      } : _objectSpread({
        job_position_data: params.jpData
      }, 'rateLimitKey' in params && params.rateLimitKey ? {
        rate_limit_key: params.rateLimitKey
      } : {});
      return this.axiosInstance.post("".concat(ENDPOINTS.jobPositions.root, "/validate_ad"), requestBody);
    }
  }, {
    key: "checkPaymentReadiness",
    value: function checkPaymentReadiness() {
      return this.axiosInstance.get("".concat(ENDPOINTS.jobPositions.root, "/payment_readiness"));
    }
  }, {
    key: "goOnline",
    value: function goOnline(_ref22) {
      var jobPositionId = _ref22.jobPositionId;
      return this.axiosInstance.post("".concat(ENDPOINTS.jobPositions.root, "/").concat(jobPositionId, "/go_online"));
    }
  }, {
    key: "indexAssessmentQuestions",
    value: function indexAssessmentQuestions(_ref23) {
      var jobPositionId = _ref23.jobPositionId;
      return this.axiosInstance.get(ENDPOINTS.jobPositions.assessmentQuestions, {
        params: {
          job_position_id: jobPositionId
        }
      });
    }
  }, {
    key: "updateAssessmentQuestions",
    value: function updateAssessmentQuestions(_ref24) {
      var jobPositionId = _ref24.jobPositionId,
          questions = _ref24.questions;
      return this.axiosInstance.put(ENDPOINTS.jobPositions.assessmentQuestions, {
        job_position_id: jobPositionId,
        questions: questions
      });
    }
  }, {
    key: "deleteAssessmentQuestion",
    value: function deleteAssessmentQuestion(_ref25) {
      var id = _ref25.id;
      return this.axiosInstance["delete"]("".concat(ENDPOINTS.jobPositions.assessmentQuestions, "/").concat(id));
    }
  }]);

  return ServiceJobPositions;
}(Service);

export var jobPositionService = function jobPositionService(_ref26) {
  var baseUrl = _ref26.baseUrl,
      jwt = _ref26.jwt;
  return new ServiceJobPositions(dynamicAxios(baseUrl, jwt));
};
export function useJobPositionsService() {
  var _useServices = useServices(),
      baseUrl = _useServices.baseUrl,
      jwt = _useServices.jwt;

  return useMemo(function () {
    return new ServiceJobPositions(dynamicAxios(baseUrl, jwt));
  }, [baseUrl, jwt]);
}
export default useJobPositionsService;
export * from './types';